import { RouteComponentProps } from 'react-router'

export enum FIELDS {
  SET_ACTIVATE_CODE = 'SET_ACTIVATE_CODE',
}

export enum Constants {
  FORM = 'CONFIRM_2FA_FORM',
}

export interface OwnProps extends RouteComponentProps {
  isLogin: boolean
  pristine: boolean
  submitting: boolean
  email: string
  isDisable: boolean
}

export interface DispatchProps {
  activateConfirmSecureUserAccount: (body: any) => any
  setHideModal: () => void
  loginWith2FA: (body: any) => void
  disable2FAConfirm: (body: any) => any
}

export type Props = OwnProps & DispatchProps
